import React from 'react';
import { motion } from 'framer-motion';

interface StepIndicatorProps {
  currentStep: number;
  totalSteps: number;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ currentStep, totalSteps }) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center">
        {Array.from({ length: totalSteps }, (_, i) => (
          <div key={i} className="flex flex-col items-center">
            <motion.div
              className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold ${
                i + 1 === currentStep
                  ? 'bg-blue-600 text-white'
                  : i + 1 < currentStep
                  ? 'bg-green-600 text-white'
                  : 'bg-gray-700 text-gray-300'
              }`}
              initial={{ scale: 0.8 }}
              animate={{ scale: i + 1 === currentStep ? 1.1 : 1 }}
              transition={{ duration: 0.3 }}
            >
              {i + 1}
            </motion.div>
            {i < totalSteps - 1 && (
              <div className="w-full h-1 bg-gray-700 mt-2">
                <motion.div
                  className="h-full bg-blue-600"
                  initial={{ width: '0%' }}
                  animate={{ width: i + 1 < currentStep ? '100%' : '0%' }}
                  transition={{ duration: 0.5 }}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator; 